import { useMemo }      from 'react';
import { connect }      from 'react-redux';
import { Dispatch }     from "redux"; 
import { ActionTypes }  from 'actions/types';
import { reducerType }  from 'reducer';
import closeVideoPlayer from './closeVideoPlayer';
import { colors }       from 'utils/colors';
import { objType }      from 'types';
import DeleteIcon       from '@mui/icons-material/Delete';
import ClearIcon        from '@mui/icons-material/Clear';
import ContentCopyIcon  from '@mui/icons-material/ContentCopy';
import { makeStyles }   from 'makeStyles';


const videoUrl = 'https://yisumatica-screen-recordings.s3.us-east-2.amazonaws.com/'



const useStyles = makeStyles()(
  (Theme) => ({    
    container: {
        width:           '33%',
        backgroundColor: '#FFF',
    },
    inner: {
        color:           colors.darkText,
        backgroundColor: '#F6F6FB',
        fontSize:        18,
        overflowY:       'scroll',
        overflowX:       'hidden',
        borderBottom:    '1px solid #DDD',
        zIndex:           10,
        '&::-webkit-scrollbar': {
            width:      '0.5em',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: `#BBB`,
            borderRadius:    10
          }
    },
    buttons: {
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'right',
        height:          60,
        fontSize:        17,
        fontWeight:      'bold',
        borderBottom:    '1px solid #DDD'
    },   
    button: {
        width:           60,
        height:          60,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        cursor:          'pointer',
        '&:hover': {
            opacity: 0.5
        }
    },
    section: {
        marginTop:    25,
        marginBottom: 10,
        marginLeft:   '7%',
        fontSize:     16,
        fontWeight:   'bold',
        cursor:       'default',
        color:        colors.primary,
    },
    item: {
        display:         'flex',
        alignItems:      'center',
        backgroundColor: '#FFF',
        borderRadius:    '0.4em',
        height:          40,
        width:           '86%',
        marginTop:       8,
        marginLeft:      '7%',
        border:          `1px solid #DDD`,
        fontSize:        16,
        fontWeight:      'bold',
        cursor:          'pointer',
        '&:hover': {
            backgroundColor: '#E6E6F0'
        }
    },
    tutorialName: {
        marginRight: 15
    }
}))

type VideoMenuProps = {
  userVideos:       objType[];
  selectedVideo:    objType;
  height:           number;
  setShowModal:     (val: boolean) => void;
  setModalVariant:  (val: string) => void;
  setSelectedVideo: (val: objType) => void;
}

const VideoMenu: React.FC<VideoMenuProps> = ({
  userVideos,
  selectedVideo,
  height,
  setShowModal,
  setModalVariant,
  setSelectedVideo
}) => {
  
  const { classes } = useStyles();
 
  const [containerStyle, innerStyle, buttonStyle] = useMemo(() => {
    return[
       {
        height: height
       },
       {
        height: height - 60
       },
       {
        fontSize: 30
       }
    ]
  },[height])
  
  
  return (
    <div 
        className = { classes.container }
        style     = { containerStyle }
    >
        <div className = { classes.buttons }>
          <div className = { classes.button }>
             <ContentCopyIcon 
                style   = { buttonStyle }
                onClick = { () => { 
                     setModalVariant('copyLink'); 
                     setShowModal(true) 
                     navigator.clipboard.writeText(`${ videoUrl }${ selectedVideo.video_id }`).then(function() {
                      console.log('Text has been copied');
                      console.log(`${ videoUrl }${ selectedVideo.video_id }`)
                    }, function(err) {
                      console.error('Could not copy text: ', err);
                    });
                  }
                }
             />
          </div>
          <div className = { classes.button }>
             <DeleteIcon 
                style   = { buttonStyle }
                onClick = { () => { setModalVariant('deleteVid'); setShowModal(true) }}
             />
          </div>
          <div className = { classes.button }>
             <ClearIcon
                onClick = { closeVideoPlayer } 
                style   = { buttonStyle }
             />
          </div>
        </div>
        <div 
          className = { classes.inner }
          style     = { innerStyle }
        >
            {
                userVideos.map((val, ind) => {
                    return(
                    <div key = { `tutorialsVideo${ val }${ ind }` }>
                        <div 
                            dir       = 'rtl'
                            className = { classes.item }
                            onClick   = { () => { setSelectedVideo(val) }}
                            style     = {{ 
                                marginBottom: ind === userVideos.length - 1 ? 20 : undefined,
                                background:   selectedVideo.video_id === val.video_id ? colors.primary : undefined,
                                color:        selectedVideo.video_id === val.video_id ? '#FFF' : undefined
                            }}
                        >
                            <div className = { classes.tutorialName } >
                               { val.title }
                            </div>
                        </div>
                    </div>
                    )
                })
            }
        </div>
    </div>
  );
}



const mapStateToProps = (reducer: reducerType) => {


  return {
    userVideos: reducer.content.userVideos,
    //lang:       reducer.components.lang
}};


const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
});



export default connect(mapStateToProps, mapDispatchToProps)(VideoMenu);







